import React, { FC } from "react";
import { UseFormRegister } from "react-hook-form";

import { CloseIcon, FillCheckIcon } from "../../SvgIcon";
import { FormError } from "../FormError";

interface IProps {
  className?: string;
  register: UseFormRegister<any>;

  title?: string;
  questions: {
    id: string;
    name: string;
    dependent?: string;
    title: string | React.ReactNode;
    subText?: string | React.ReactNode;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    onBlur?: React.ChangeEventHandler<HTMLInputElement>;
  }[];
  errors?: any;
  titleClasses?: string;
  watch: any;
}

export const GroupRadio: FC<IProps> = ({ title, register, watch, questions, errors, titleClasses = "text-base" }) => {
  return (
    <div className="mb-4">
      <div className="grid grid-cols-10 p-3">
        <div className="col-span-8">{title ?? ""} </div>
        <div className="flex flex-col items-end justify-center font-bold">Yes</div>
        <div className="flex flex-col items-end justify-center font-bold">No</div>
      </div>

      <div className="space-y-5">
        {questions.map((question, idx) => {
          const [p_key, s_key] = question.name.split(".");

          const error =
            errors !== undefined && errors[p_key]
              ? s_key
                ? errors[p_key][s_key]?.message
                : errors[p_key]?.message
              : "";

          return question.dependent ? (
            watch(question.dependent) === "yes" ? (
              <div key={+idx} className="grid grid-cols-10 bg-gray-100 rounded-lg p-3">
                <div className="col-span-8">
                  <p className={`${titleClasses} mb-2`}>{question?.title}</p>

                  {question.subText ? <p className="text-xs italic text-gray-500 mb-2">{question.subText}</p> : null}
                  {error ? <FormError error={error} id={question.id} /> : null}
                </div>
                <div className="flex flex-col items-end justify-center">
                  <label htmlFor={question.id + "yes"}>
                    {watch(question.name) === "yes" ? (
                      <FillCheckIcon strokeColor="text-green-600 w-5 h-5" />
                    ) : (
                      <div className="w-5 h-5 rounded-full bg-gray-300" />
                    )}
                  </label>
                  <input
                    {...register(question.name, { onChange: question.onChange })}
                    id={question.id + "yes"}
                    type="radio"
                    value="yes"
                    disabled={question.disabled}
                    readOnly={question.readOnly}
                    hidden
                  />
                </div>
                <div className="flex flex-col items-end justify-center">
                  <label htmlFor={question.id + "no"}>
                    {watch(question.name) === "no" ? (
                      <div className="w-5 h-5 bg-red-500 rounded-full flex justify-center items-center">
                        <CloseIcon strokeColor="text-white w-4 h-4" />
                      </div>
                    ) : (
                      <div className="w-5 h-5 rounded-full bg-gray-300" />
                    )}
                  </label>
                  <input
                    {...register(question.name, { onChange: question.onChange })}
                    id={question.id + "no"}
                    type="radio"
                    value="no"
                    disabled={question.disabled}
                    readOnly={question.readOnly}
                    hidden
                  />
                </div>
              </div>
            ) : null
          ) : (
            <div key={+idx} className="grid grid-cols-10 bg-gray-100 rounded-lg p-3">
              <div className="col-span-8">
                <p className={`${titleClasses} mb-2`}>{question?.title}</p>
                {question.subText ? <p className="text-xs italic text-gray-500 mb-2">{question.subText}</p> : null}
                {error ? <FormError error={error} id={question.id} /> : null}
              </div>
              <div className="flex flex-col items-end justify-center">
                <label htmlFor={question.id + "yes"}>
                  {watch(question.name) === "yes" ? (
                    <FillCheckIcon strokeColor="text-green-600 w-5 h-5" />
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-300" />
                  )}
                </label>
                <input
                  {...register(question.name, { onChange: question.onChange })}
                  id={question.id + "yes"}
                  type="radio"
                  value="yes"
                  disabled={question.disabled}
                  readOnly={question.readOnly}
                  className="w-5 h-5"
                  hidden
                />
              </div>
              <div className="flex flex-col items-end justify-center">
                <label htmlFor={question.id + "no"}>
                  {watch(question.name) === "no" ? (
                    <div className="w-5 h-5 bg-red-500 rounded-full flex justify-center items-center">
                      <CloseIcon strokeColor="text-white w-4 h-4" />
                    </div>
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-300" />
                  )}
                </label>
                <input
                  {...register(question.name, { onChange: question.onChange })}
                  id={question.id + "no"}
                  type="radio"
                  value="no"
                  disabled={question.disabled}
                  readOnly={question.readOnly}
                  className="w-5 h-5"
                  hidden
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
